import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Initially hide the sidebar i.e. when navigating back to the page
    this.close();
  }

  toggle(event) {
    event.preventDefault();
    const active = this.element.classList.toggle("sidebar--active");
    this.dispatch("toggle", { detail: { active } });
    this.bindHotkeys(active);
  }

  close(event) {
    if (event) {
      event.preventDefault();

      // Ignore dispatched events from self
      if (event.detail.active && event.target === this.element) {
        return;
      }
    }

    this.element.classList.remove("sidebar--active");
    this.bindHotkeys(false);
  }

  bindHotkeys(active) {
    if (active) {
      this.hotkeyListener = (event) => {
        // Handle Firefox 65+/IME composition mode
        // See https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event
        if (event.isComposing || event.keyCode === 229) {
          return;
        }
        if (event.key === "Escape") {
          this.close();
        }
      };
      addEventListener("keydown", this.hotkeyListener);
    } else {
      if (this.hotkeyListener) {
        removeEventListener("keydown", this.hotkeyListener);
      }
    }
  }
}
